import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type Session from "cc-frontend/services/session"

export default class DefaultNavbar extends Component {
  @service declare session: Session

  @service declare router

  @action
  signInOrUp() {
    let path = this.router.currentURL

    this.router.transitionTo("user.sign", { queryParams: { afterSignInRedirectTo: path } })
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    DefaultNavbar: typeof DefaultNavbar
  }
}
